import { render, staticRenderFns } from "./integralLogsList.vue?vue&type=template&id=207a51df&scoped=true"
import script from "./integralLogsList.vue?vue&type=script&lang=js"
export * from "./integralLogsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "207a51df",
  null
  
)

export default component.exports